import { gql } from "graphql-tag";

export const GET_ANALYTICS_SCORE_CARDS = gql`
    query ScoreCardsAnalytics($params: GetAnalyticsInput!) {
        scoreCardsAnalytics(params: $params)
    }
`;
